import { Alert, Loader } from '@fluentui/react-northstar';
import { useTranslation } from 'react-i18next';

// A route that redirects to a specific page (base64 encoded as a query param)
const RedirectRoute = () => {
  const { t } = useTranslation();
  const redirectUrl = new URLSearchParams(document.location.search).get('url');

  if (redirectUrl) {
    document.location.href = atob(redirectUrl);

    return (<Loader label={t("Redirect.Loader")} />);
  }

  return (<Alert
    danger
    content={t("Redirect.Error")}
    style={{ padding: 20 }}
  />);
};

export default RedirectRoute;
